import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import DoctorsTable from './doctorsTable';
import constant from '../../constant';

const DoctorsContent = () => {
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { hospitalId } = useParams();

  useEffect(() => {
    const fetchDoctors = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('No authentication token found');
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${constant.REACT_APP_API_URL}/hospital/${hospitalId}/doctor/`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const result = await response.json();
        if (response.ok) {
          setDoctors(result.map(doctor => ({
            doctor_id: doctor.doctor_id,
            name: doctor.name,
            email: doctor.email,
            mobile: doctor.mobile,
            is_active: doctor.is_active,
          })));
        } else {
          setError(result.message || 'Failed to fetch doctors');
        }
      } catch (error) {
        setError('Error fetching doctors');
      } finally {
        setLoading(false);
      }
    };

    fetchDoctors();
  }, [hospitalId]);

  const handleDelete = async (id) => {
    const token = localStorage.getItem('token');
    if (!token) {
      setError('No authentication token found');
      return;
    }

    try {
      const response = await fetch(`${constant.REACT_APP_API_URL}/hospital/${hospitalId}/doctor/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const result = await response.json();
      if (response.ok) {
        setDoctors(doctors.filter((doctor) => doctor.doctor_id !== id));
      } else {
        setError(result.message || 'Failed to delete doctor');
      }
    } catch (error) {
      setError('Error deleting doctor');
    }
  };

  const handleEdit = (updatedDoctor) => {
    setDoctors(doctors.map((doctor) =>
      doctor.doctor_id === updatedDoctor.doctor_id ? updatedDoctor : doctor
    ));
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-full">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-10 text-red-500">
        {error}
        <button
          onClick={() => setError(null)}
          className="ml-4 px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
        >
          Clear Error
        </button>
      </div>
    );
  }

  return (
    <div className="px-6 pt-16 md:pt-0">
      <div className="">
        <DoctorsTable
          doctors={doctors}
          onDelete={handleDelete}
          onEdit={handleEdit}
        />
      </div>
    </div>
  );
};

export default DoctorsContent;